import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatToolbarModule } from '@angular/material/toolbar';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { BreakpointService } from '../../services/breakpoint.service';
/**
 * component rendering the menu bar to slowly move into Material Design direction
 * - inspired by https://material.angular.io/components/menu/overview
 */
@Component({
    selector: 'app-menu-bar',
    imports: [
        RouterLink,
        RouterLinkActive,
        MatButtonModule,
        MatToolbarModule
    ],
    templateUrl: './menu-bar.component.html',
    styleUrls: ['./menu-bar.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MenuBarComponent {
  breakpointService = inject(BreakpointService);

}
